import { useDebouncedCallback } from 'use-debounce';

export default function useCasEnabledDebouncedCallback(callback: any, enabled?: boolean) {
  const debounced = useDebouncedCallback(callback, enabled ? 250 : 0);
  return debounced;
}
